module.exports = __webpack_public_path__ + "img/loop.d55a5007.svg";